import {
    DrawerSvccCuerpo,
    DrawerSvccPie,
    DrawerSvccSeccion
} from '../../../../components/drawer/DrawerSvcc';
import CamposSvcc from '../../../../components/drawer/CamposSvcc';

const DosimetryForm = ({ dosimetryForm, handleSubmit, handleCancelClick, onlyVisual }: any) => {
    const { formData, dosimetryFieldsConfig, errors, handleChange, translate } = dosimetryForm;

    return (
        <>
            <DrawerSvccCuerpo>
                <DrawerSvccSeccion titulo={translate('radiologicalEquipmentForm.tabs.dosimetry')}>
                    <CamposSvcc
                        config={dosimetryFieldsConfig}
                        formData={formData}
                        errors={errors}
                        onChange={handleChange}
                        onlyVisual={onlyVisual}
                    />
                </DrawerSvccSeccion>
            </DrawerSvccCuerpo>
            <DrawerSvccPie
                onCancelar={handleCancelClick}
                onConfirmar={handleSubmit}
                textoCancelar={translate('radiologicalEquipmentForm.buttons.cancel')}
                textoConfirmar={translate('radiologicalEquipmentForm.buttons.next')}
                nota={
                    onlyVisual
                        ? undefined
                        : translate('radiologicalEquipmentForm.notaPaso', { paso: 2 })
                }
                sinConfirmar={onlyVisual}
            />
        </>
    );
};

export default DosimetryForm;
